module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGGyumaoC-6d64b157c146e1fe3ab113d4e7d42c69.png";